import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box19_AdditionalClaim: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">
        19. ADDITIONAL CLAIM INFORMATION (Designated by NUCC)
      </Typography>
      <Controller
        name="additionalClaimInfo"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            multiline
            minRows={1}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                padding: '0',
                fontSize: '13px',
              },
              '& .MuiInputBase-input': {
                padding: '4px 8px',
                fontSize: '13px',
              },
            }}
          />
        )}
      />
    </>
  );
};